<template>
  <div class="app-container">
    <div v-html="compiledMarkdown" class="markdown-content"></div>
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  data() {
    return {
      compiledMarkdown: '',
    };
  },
  async created() {
    await this.loadMarkdown();
  },
  methods: {
    async loadMarkdown() {
      try {
        const response = await fetch('/index.md');
        const markdown = await response.text();
        this.compiledMarkdown = marked(markdown);
      } catch (error) {
        console.error('Error loading markdown:', error);
        this.compiledMarkdown = '<p>Error loading content.</p>';
      }
    },
  },
};
</script>

<style scoped>
</style>
